import { render, staticRenderFns } from "./hock.vue?vue&type=template&id=3126ab4a&scoped=true"
import script from "./hock.vue?vue&type=script&lang=js"
export * from "./hock.vue?vue&type=script&lang=js"
import style0 from "./hock.vue?vue&type=style&index=0&id=3126ab4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3126ab4a",
  null
  
)

export default component.exports